import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as FaireDirectQueryParameters } from "@faire/web-api--source/routes/user/sign-up";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import {
  SAMPLE_PROSPECTING_POST_SAMPLE_QUERY_PARAM_VALUE,
  SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE,
} from "@faire/retailer/components/App/AppModals/consts";
import { useIsBrandPreview } from "@faire/retailer/lib/getIsBrandPreview";
import {
  SignUpElement,
  SignUpType,
  usePopSignUp,
} from "@faire/retailer/lib/popSignUp";
import { getIsRobot } from "@faire/retailer/serialized-data/getIsRobot";

export const useFaireDirectLandingPagePopSignUpEffect = () => {
  const [autoSignUpSeen, setAutoSignUpSeen] = useState(false);

  const isBrandPreview = useIsBrandPreview();
  const { search } = useLocation();
  const { signUp } = useQueryParams(FaireDirectQueryParameters.parse);
  const { popSignUp } = usePopSignUp();
  const isRobot = getIsRobot();

  const shouldPopSignUp =
    !autoSignUpSeen &&
    !isBrandPreview &&
    !isRobot &&
    !search.includes("signIn") &&
    signUp !== SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE &&
    signUp !== SAMPLE_PROSPECTING_POST_SAMPLE_QUERY_PARAM_VALUE;

  const autoSignUp = useCallback(() => {
    popSignUp(SignUpType.FAIRE_DIRECT, () => {}, {
      element: SignUpElement.AUTO_POPUP,
      sourceId: "faire_direct_root_auto_signup",
    });
    setAutoSignUpSeen(true);
  }, [popSignUp, setAutoSignUpSeen]);

  useEffect(() => {
    if (shouldPopSignUp) {
      autoSignUp();
    }
  }, [shouldPopSignUp, autoSignUp]);
};
